import React from 'react';
import { GetFlowComments, CreateFlowComment } from 'src/graphql/cashflow';
import RepositoryCommentsTab from 'src/components/repositorio/RepositoryCommentsTab';

/**
 * Wrapper that fetches flow comments lazily (when sidebar opens) and renders
 * RepositoryCommentsTab with flow-specific mutation.
 */
const FlowCommentsTab = ({ editData, companyIdOverride }) => {
  const flowId = editData?.id;
  const companyId = editData?.companyId || companyIdOverride;

  const { data: commentsData, reexecuteQuery } = GetFlowComments({
    flowId,
    companyId,
    pause: !flowId || !companyId,
  });

  const createFlowComment = CreateFlowComment();

  const comments = commentsData?.getFlowComments || [];
  const data = {
    id: flowId,
    companyId,
    innerComments: comments,
  };

  const onCommentCreated = async (input) => {
    const { error } = await createFlowComment.executeMutation({
      flowId,
      companyId,
      userId: input.user?.id,
      userName: input.user?.name,
      userEmail: input.user?.email,
      date: input.date,
      comment: input.comment,
    });
    if (error) throw error;
    reexecuteQuery();
  };

  return (
    <RepositoryCommentsTab
      data={data}
      companyIdOverride={companyIdOverride}
      onCommentCreated={onCommentCreated}
      submitLoading={createFlowComment.fetching}
    />
  );
};

export default FlowCommentsTab;
